export default __webpack_public_path__ + "static/media/avatar3.f95c4af6.png";